import * as _ from "lodash";

import { ColumnData, Column } from "@ctra/api";

import { ChartContextType } from "../../../../providers";
import { ColumnChartProcessor } from "./Core";

export class MultiEntityColumnChartProcessor extends ColumnChartProcessor {
  public identity = "MultiEntityColumnChartProcessor";

  mayGroup(): boolean {
    return true;
  }

  getConsolidatedData(
    data: ChartContextType<ColumnData>["values"]["data"],
    meta: ChartContextType<ColumnData>["values"]["meta"],
    series: ChartContextType<ColumnData>["values"]["series"]
  ): ChartContextType<ColumnData>["values"]["data"] {
    const filteredData = this.getFilteredRawData(data, meta, series);

    return _.mapValues(filteredData, (columnCollection, chartID) => {
      const [groupField] = _.split(chartID, "-");

      return _.map(columnCollection, (column) => ({
        ...column,
        groupField
      }));
    });
  }

  /**
   * Remove the undefined values from the filtered data
   * @param {ChartContextType<ColumnData>["values"]["data"]} data
   * @param {ChartContextType<ColumnData>["values"]["meta"]} meta
   * @param {ChartContextType<ColumnData>["values"]["series"]} series
   * @returns {Column}
   */
  getData(
    data: ChartContextType<ColumnData>["values"]["data"],
    meta: ChartContextType<ColumnData>["values"]["meta"],
    series: ChartContextType<ColumnData>["values"]["series"]
  ): Column {
    return _.flatMap(_.omitBy(this.getConsolidatedData(data, meta, series), _.isUndefined)) as Column;
  }
}
